import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";

import { defaultPRD3011_R01DowntimeDto, defaultPRD3011_R01HeaderDto, defaultPRD3011_R01InspectDto, PRD3011_R01DowntimeDto, PRD3011_R01HeaderDto, PRD3011_R01InspectDto, PRD3011_R01DetailDto, defaultPRD3011_R01DetailDto } from './Dto_PRD3011_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { calculateTotalOrderQty } from 'src/components/common/common';


export interface PRD3011_R01Filter {

	dateRange: DateRange | undefined	;
	compCd: string;
	compNm: string;
	workplaceCd: string;
	itemCd: string;
	itemNm: string;
	workEmp: string;
	workEmpNm: string;
	/** 저장 시 품목 라벨 자동 출력 (Y/N) */
	labelPrintAuto: string;
}
export interface Store_PRD3011_R01 {
	PRD3011_R01Filter: PRD3011_R01Filter;
	PRD3011_R01PastFilter: PRD3011_R01Filter;
	setPRD3011_R01Filter: (filter: Partial<Store_PRD3011_R01['PRD3011_R01Filter']>) => void;
	setPRD3011_R01PastFilter: (filter: Store_PRD3011_R01['PRD3011_R01PastFilter']) => void;
	
	// ====== 생산실적 리스트 및 선택/편집 ======
	PRD3011_R01List: PRD3011_R01HeaderDto[];
	setPRD3011_R01List: (dataList: PRD3011_R01HeaderDto[]) => void;

	editPRD3011_R01: PRD3011_R01HeaderDto | null;
	setEditPRD3011_R01: (editSale: PRD3011_R01HeaderDto | null) => void;

	selectedPRD3011_R01: PRD3011_R01HeaderDto | undefined;
	setSelectedPRD3011_R01: (data: PRD3011_R01HeaderDto | undefined) => void;
	initSelectedPRD3011_R01: () => void;

	// ====== 자재출고 상세(디테일) 데이터 ======
	PRD3011_R01DetailList: PRD3011_R01DetailDto[];
	setPRD3011_R01DetailList: (data: PRD3011_R01DetailDto[]) => void;
	insertPRD3011_R01DetailList: (data: PRD3011_R01DetailDto[], index?: number) => void;
	removePRD3011_R01DetailList: (index: number) => void;
	updatePRD3011_R01DetailList: (index: number, data: PRD3011_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedPRD3011_R01DetailList: string[];
	setSelectedPRD3011_R01DetailList: (idList: string[]) => void;
	addSelectedPRD3011_R01DetailList: (idList: string[]) => void;
	removeSelectedPRD3011_R01DetailList: (idList?: string[]) => void;
	initSelectedPRD3011_R01DetailList: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3011_R01DetailList: string[];
	setDeletedPRD3011_R01DetailList: (idList: string[]) => void;
	addDeletedPRD3011_R01DetailList: (idList: string[]) => void;
	removeDeletedPRD3011_R01DetailList: (idList?: string[]) => void;

	originalPRD3011_R01DetailList: PRD3011_R01DetailDto[];
	setOriginalPRD3011_R01DetailList: (data: PRD3011_R01DetailDto[]) => void;

	// ====== 생산실적 불량 상세(디테일) 데이터 ======
	PRD3011_R01InspectList: PRD3011_R01InspectDto[];
	setPRD3011_R01InspectList: (data: PRD3011_R01InspectDto[]) => void;
	insertPRD3011_R01InspectList: (data: PRD3011_R01InspectDto[], index?: number) => void;
	removePRD3011_R01InspectList: (index: number) => void;
	updatePRD3011_R01InspectList: (index: number, data: PRD3011_R01InspectDto) => void;

	// ====== 선택(디테일) 불량 행 선택/삭제 관리 ======
	selectedPRD3011_R01InspectList: string[];
	setSelectedPRD3011_R01InspectList: (idList: string[]) => void;
	addSelectedPRD3011_R01InspectList: (idList: string[]) => void;
	removeSelectedPRD3011_R01InspectList: (idList?: string[]) => void;
	initSelectedPRD3011_R01InspectList: () => void;

	// ====== 생산실적 불량 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3011_R01InspectList: string[];
	setDeletedPRD3011_R01InspectList: (idList: string[]) => void;
	addDeletedPRD3011_R01InspectList: (idList: string[]) => void;
	removeDeletedPRD3011_R01InspectList: (idList?: string[]) => void;

	originalPRD3011_R01InspectList: PRD3011_R01InspectDto[];
	setOriginalPRD3011_R01InspectList: (data: PRD3011_R01InspectDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;	
	inspectColumnState: ColumnState[] | null;
	setInspectColumnState: (state: ColumnState[] | null) => void;
		
	allCount: number;					setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;		setDetailFetchTrigger: (trigger: boolean) => void;
	

	productResultComplete: boolean;
	setProductResultComplete: (productResultComplete: boolean) => void;

	modalVisible: boolean;
	setModalVisible: (modalVisible: boolean) => void;
	
	//화면의 초기 로드 플래그
	isInitialLoad: boolean;
	setIsInitialLoad: (isInitialLoad: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	inspectScrollTop: number | null;
	setInspectScrollTop: (top: number | null) => void;

	// ====== 초기화 ======
	initData: () => void;

	// 창고 코드 필터링
	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	outWarehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	badWarehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => void;
}

export const calculateBomUsingQty = (
	editPRD3011_R01: PRD3011_R01HeaderDto | null,
	detailItem: PRD3011_R01DetailDto,
): number => {
	if (!editPRD3011_R01) return detailItem.bomUsingQty;

	const productQty = Number(editPRD3011_R01.productQty) || 0;
	const badQty = Number(editPRD3011_R01.badQty) || 0;
	const totalProductionQty = productQty + badQty;
	const fixLossqty = (totalProductionQty > 0) ? detailItem.fixLossqty || 0 : 0;

	return calculateTotalOrderQty(totalProductionQty, detailItem.prntItemQty ?? 1, detailItem.childItemUsage, detailItem.lossPercent, fixLossqty);
};

const recalculateDetailListWithTransport = (
	detailList: PRD3011_R01DetailDto[],
	editHeader: PRD3011_R01HeaderDto | null,
): PRD3011_R01DetailDto[] => {
	const allocatedQtyMap = new Map<string, number>();

	return detailList.map(item => {
		const bomUsingQty = calculateBomUsingQty(editHeader, item);
		const groupKey = `${item.warehouseCd ?? ''}::${item.childItemcd ?? ''}`;
		const currentAllocated = allocatedQtyMap.get(groupKey) || 0;
		const remainingNeeded = Math.max(0, bomUsingQty - currentAllocated);

		let transportQty = 0;
		if (remainingNeeded > 0) {
			transportQty = Math.min(remainingNeeded, item.lotQty);
		}

		allocatedQtyMap.set(groupKey, currentAllocated + transportQty);

		let isModified = transportQty > 0 || item.transportQty !== transportQty;
		if (transportQty === 0) {
			isModified = false;
		}

		return { ...item, bomUsingQty, transportQty, isModified };
	});
};

export const defaultPRD3011_R01Filter : PRD3011_R01Filter = {

	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: getFutureWeekdayExceptTodayAndTomorrow()
	},
	compCd: '',
	compNm: '',
	workplaceCd: '',
	itemCd: '',
	itemNm: '',
	workEmp: '',
	workEmpNm: '',
	labelPrintAuto: 'N',
};

const getInitialPRD3011_R01HeaderDto = (): PRD3011_R01HeaderDto => {
	const { compCdList, workPlaceList, wmsCdList, warehouseCdList, itemStatusList } = useCommonCodeStore.getState();

	const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
    
    const warehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && (value.productYn === 'Y' || value.manufactYn === 'Y' )
    ));
    const outWarehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && (value.materialYn === 'Y' || value.manufactYn === 'Y' )
    ));
    const badWarehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && value.badYn === 'Y'
    ));

	return {
		...defaultPRD3011_R01HeaderDto,
		compCd: compCdList?.[0]?.compCd || '',
		workplaceCd: workPlaceList?.[0]?.workplaceCd || '',
		logicCenter: defaultLogicCenter,
        warehouseCd: warehouseCdListToUse?.[0]?.warehouseCd || '',
        outWarehouseCd: outWarehouseCdListToUse?.[0]?.warehouseCd || '',
        badWarehouseCd: badWarehouseCdListToUse?.[0]?.warehouseCd || '',
        itemStatus: itemStatusList?.[0]?.minorCd || '',
		itemCd: '',
		itemNm: '',
	}
};

export const usePRD3011_R01Store = create<Store_PRD3011_R01>((set, get) => ({
	PRD3011_R01Filter: defaultPRD3011_R01Filter,
	PRD3011_R01PastFilter: defaultPRD3011_R01Filter,
	setPRD3011_R01Filter: (update) => set((state) => ({
		PRD3011_R01Filter: {
			...state.PRD3011_R01Filter,
			...update
		}
	})),
	setPRD3011_R01PastFilter: (filter: Store_PRD3011_R01['PRD3011_R01PastFilter']) => set((state) => {
		return {
			...state,
			PRD3011_R01PastFilter: filter
		}
	}),

	// ====== 생산실적 리스트 및 선택/편집 ======
	PRD3011_R01List: [],
	setPRD3011_R01List: (dataList: PRD3011_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			PRD3011_R01List: dataList
		}
	}),

	editPRD3011_R01: getInitialPRD3011_R01HeaderDto(),
	setEditPRD3011_R01: (editSale: PRD3011_R01HeaderDto | null) => set((state) => {
		const productionQtyChanged = editSale != null
			&& (state.editPRD3011_R01?.productQty !== editSale.productQty
				|| state.editPRD3011_R01?.badQty !== editSale.badQty);

		const newDetailList = productionQtyChanged
			? recalculateDetailListWithTransport(state.PRD3011_R01DetailList, editSale)
			: state.PRD3011_R01DetailList;

		return {
			...state,
			editPRD3011_R01: editSale,
			PRD3011_R01DetailList: newDetailList,
		};
	}),

	selectedPRD3011_R01: undefined,
	
	setSelectedPRD3011_R01: (data: PRD3011_R01HeaderDto | undefined) => set((state) => {
		return { 
			selectedPRD3011_R01: data, 
			selectedPRD3011_R01DetailList: [], deletedPRD3011_R01DetailList: [],
			selectedPRD3011_R01InspectList: [], deletedPRD3011_R01InspectList: [],
			detailFetchTrigger: true,
			detailScrollTop: null,
			inspectScrollTop: null,
		};
	}),
	initSelectedPRD3011_R01: () => {
		set({
			selectedPRD3011_R01: undefined,
			editPRD3011_R01: getInitialPRD3011_R01HeaderDto(),
			detailFetchTrigger: false,
		});
	},

	// ====== 자재출고 상세(디테일) 데이터 ======
	PRD3011_R01DetailList: [],
	setPRD3011_R01DetailList: (data: PRD3011_R01DetailDto[]) => set((state) => {
		// console.log('setPRD3011_R01DetailList 호출 :', data);
		let newList: PRD3011_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultPRD3011_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			PRD3011_R01DetailList: recalculateDetailListWithTransport(newList, state.editPRD3011_R01),
		}
	}),
	insertPRD3011_R01DetailList: (data: PRD3011_R01DetailDto[], index?: number) => set((state) => {
		let newPRD3011_R01DetailList = [...state.PRD3011_R01DetailList];

		let targetRowData = newPRD3011_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newPRD3011_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newPRD3011_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newPRD3011_R01DetailList = newPRD3011_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newPRD3011_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultPRD3011_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newPRD3011_R01DetailList.splice(index, 0, ...newData);
		} else {
			newPRD3011_R01DetailList.push(...newData);
		}

		return {
			...state,
			PRD3011_R01DetailList: newPRD3011_R01DetailList
		}
	}),
	removePRD3011_R01DetailList: (index: number) => set((state) => {
		const newPRD3011_R01DetailList = [...state.PRD3011_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			PRD3011_R01DetailList: newPRD3011_R01DetailList
		}
	}),
	updatePRD3011_R01DetailList: (valueIndex: number, data: PRD3011_R01DetailDto) => set((state) => {
		const _PRD3011_R01DetailList = state.PRD3011_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? { ...data, isModified: true } : item
		);

		if(data.transportQty < 0) {
			showWarning('출고량은 0보다 작을 수 없습니다.');
			data.transportQty = 0;
		}
		return {
			...state,
			PRD3011_R01DetailList: _PRD3011_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3011_R01DetailList: [],
	setDeletedPRD3011_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedPRD3011_R01DetailList: idList
		}
	}),
	addDeletedPRD3011_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedPRD3011_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.PRD3011_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.PRD3011_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedPRD3011_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedPRD3011_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedPRD3011_R01DetailList: [...state.deletedPRD3011_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedPRD3011_R01DetailList: [],
	setSelectedPRD3011_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedPRD3011_R01DetailList: idList
		}
	}),
	addSelectedPRD3011_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedPRD3011_R01DetailList = [...state.selectedPRD3011_R01DetailList];
		if(idList.length > 0) {
			_selectedPRD3011_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedPRD3011_R01DetailList: _selectedPRD3011_R01DetailList
		}
	}),
	removeSelectedPRD3011_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedPRD3011_R01DetailList: [...state.selectedPRD3011_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedPRD3011_R01DetailList: () => set({ selectedPRD3011_R01DetailList: [] }),	

	originalPRD3011_R01DetailList: [],
	setOriginalPRD3011_R01DetailList: (data: PRD3011_R01DetailDto[]) => set((state) => {
		let newList: PRD3011_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultPRD3011_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalPRD3011_R01DetailList: newList
		}
	}),

	// ====== 생산실적 불량 상세(디테일) 데이터 ======
	PRD3011_R01InspectList: [],
	setPRD3011_R01InspectList: (data: PRD3011_R01InspectDto[]) => set((state) => {
		let newList: PRD3011_R01InspectDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultPRD3011_R01InspectDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			PRD3011_R01InspectList: newList
		}
	}),
	insertPRD3011_R01InspectList: (data: PRD3011_R01InspectDto[], index?: number) => set((state) => {
		const newPRD3011_R01InspectList = [...state.PRD3011_R01InspectList];

		//let valueIndex = newSYS4100_R01List.length + 1;
		let valueIndex = Math.max(0, ...newPRD3011_R01InspectList.map(item => item.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		// 같은 orderIndex를 가진 행들 중에서 가장 큰 orderIndexSeq 값을 찾는다.
		const maxOrderIndexSeq = Math.max(0, ...newPRD3011_R01InspectList
			.filter(item => item.orderIndex === targetOrderIndex)
			.map(item => item.orderIndexSeq || 0)
		);
		let targetOrderIndexSeq = maxOrderIndexSeq + 1;
		// console.log('newPRD3011_R01InspectList : ', newPRD3011_R01InspectList);
		// console.log('valueIndex : ', valueIndex 
		// 				+ ' 멤버 index : ' + index
		// 				+ ' 최종 orderIndex : ' + targetOrderIndex
		// 				+ ' 최종 orderIndexSeq : ' + targetOrderIndexSeq
		// 			);
		
		const newData = data.map(item => ({ ...defaultPRD3011_R01InspectDto, ...item, 
			valueIndex: valueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: targetOrderIndexSeq
		}));
		if (index !== undefined) {
			newPRD3011_R01InspectList.splice(index, 0, ...newData);
		} else {
			newPRD3011_R01InspectList.push(...newData);
		}
		return {
			...state,
			PRD3011_R01InspectList: newPRD3011_R01InspectList
		}
	}),
	removePRD3011_R01InspectList: (index: number) => set((state) => {
		const newPRD3011_R01InspectList = [...state.PRD3011_R01InspectList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			PRD3011_R01InspectList: newPRD3011_R01InspectList
		}
	}),
	updatePRD3011_R01InspectList: (valueIndex: number, data: PRD3011_R01InspectDto) => set((state) => ({
		...state,
		PRD3011_R01InspectList: state.PRD3011_R01InspectList.map(item =>
			item.valueIndex === valueIndex ? data : item
		),
	})),

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedPRD3011_R01InspectList: [],
	setDeletedPRD3011_R01InspectList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedPRD3011_R01InspectList: idList
		}
	}),
	addDeletedPRD3011_R01InspectList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedPRD3011_R01InspectList];

		for(const valueIndex of idList) {
			const isInserted = state.PRD3011_R01InspectList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.PRD3011_R01InspectList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedPRD3011_R01InspectList: _deletedLotList
		}
	}),
	removeDeletedPRD3011_R01InspectList: (idList?: string[]) => set((state) => ({
		...state,
		deletedPRD3011_R01InspectList: [...state.deletedPRD3011_R01InspectList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedPRD3011_R01InspectList: [],
	setSelectedPRD3011_R01InspectList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedPRD3011_R01InspectList: idList
		}
	}),
	addSelectedPRD3011_R01InspectList: (idList: string[]) => set((state) => {
		const _selectedPRD3011_R01InspectList = [...state.selectedPRD3011_R01InspectList];
		if(idList.length > 0) {
			_selectedPRD3011_R01InspectList.push(...idList);
		}
		return {
			...state,
			selectedPRD3011_R01InspectList: _selectedPRD3011_R01InspectList
		}
	}),
	removeSelectedPRD3011_R01InspectList: (idList?: string[]) => set((state) => ({
		...state,
		selectedPRD3011_R01InspectList: [...state.selectedPRD3011_R01InspectList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedPRD3011_R01InspectList: () => set({ selectedPRD3011_R01InspectList: [] }),

	originalPRD3011_R01InspectList: [],
	setOriginalPRD3011_R01InspectList: (data: PRD3011_R01InspectDto[]) => set((state) => {
		let newList: PRD3011_R01InspectDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultPRD3011_R01InspectDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalPRD3011_R01InspectList: newList
		}
	}),


	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),
	inspectColumnState: null,
	setInspectColumnState: (state: ColumnState[] | null) => set({ inspectColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	productResultComplete: false,
	setProductResultComplete: (productResultComplete: boolean) => set({ productResultComplete }),

	modalVisible: false,
	setModalVisible: (modalVisible: boolean) => set({ modalVisible }),

	isInitialLoad: true,
	setIsInitialLoad: (isInitialLoad: boolean) => set({ isInitialLoad }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	inspectScrollTop: null,
	setInspectScrollTop: (top: number | null) => set({ inspectScrollTop: top }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		PRD3011_R01Filter: defaultPRD3011_R01Filter,
		PRD3011_R01PastFilter: defaultPRD3011_R01Filter,
		PRD3011_R01List: [],
		selectedPRD3011_R01: undefined,
		editPRD3011_R01: getInitialPRD3011_R01HeaderDto(),

		PRD3011_R01InspectList: [],
		deletedPRD3011_R01InspectList: [],
		selectedPRD3011_R01InspectList: [],
		originalPRD3011_R01InspectList: [],

		allCount: 0,
		detailFetchTrigger: false,
		isInitialLoad: true,
		scrollTop: null,
		detailScrollTop: null,
		inspectScrollTop: null,
	})),

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		const filteredList = warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.productYn === 'Y')
			// && (value.productYn === 'Y' || value.goodsYn === 'Y')
		));
		
		if (filteredList.length === 0) {
			return [{ warehouseCd: '', warehouseNm: '' } as WareHouseDto];
		}
		
		return filteredList;
	},
	outWarehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		const filteredList = warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.materialYn === 'Y' || value.manufactYn === 'Y')
		));
		
		if (filteredList.length === 0) {
			return [{ warehouseCd: '', warehouseNm: '' } as WareHouseDto];
		}
		
		return filteredList;
	},
	badWarehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		const filteredList = warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& value.badYn === 'Y'
		));
		
		if (filteredList.length === 0) {
			return [{ warehouseCd: '', warehouseNm: '' } as WareHouseDto];
		}
		
		return filteredList;
	},

	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => {
		const { compCdList, workPlaceList, wmsCdList, itemStatusList } = useCommonCodeStore.getState();
		const state = get();
		
		if (compCdList.length === 0) return;

		const defaultCompCd = compCdList?.[0]?.compCd || '';
		const defaultWorkplaceCd = workPlaceList?.[0]?.workplaceCd || '';
		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		const defaultItemStatus = itemStatusList?.[0]?.minorCd || '';

		const warehouseCdListToUse = state.warehouseCdListToUseList(defaultLogicCenter);
		const outWarehouseCdListToUse = state.outWarehouseCdListToUseList(defaultLogicCenter);
		const badWarehouseCdListToUse = state.badWarehouseCdListToUseList(defaultLogicCenter);

		const defaultWarehouseCd = warehouseCdListToUse?.[0]?.warehouseCd || '';
		const defaultOutWarehouseCd = outWarehouseCdListToUse?.[0]?.warehouseCd || '';
		const defaultBadWarehouseCd = badWarehouseCdListToUse?.[0]?.warehouseCd || '';
		
		let newEditHeader = state.editPRD3011_R01;
		let needUpdate = false;

		if (!state.PRD3011_R01Filter?.compCd) {
			needUpdate = true;
		}

		if (state.editPRD3011_R01 && (!state.editPRD3011_R01.compCd || !state.editPRD3011_R01.logicCenter)) {
			newEditHeader = {
				...state.editPRD3011_R01,
				compCd: defaultCompCd,
				workplaceCd: defaultWorkplaceCd,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				outWarehouseCd: defaultOutWarehouseCd,
				badWarehouseCd: defaultBadWarehouseCd,
				itemStatus: defaultItemStatus,
			};
			needUpdate = true;
		}

		if (needUpdate) {
			set({
				editPRD3011_R01: newEditHeader
			});
		}
	},

	
}));
